import React, { useMemo, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createCustomTheme } from '../theme';
import useSettings from '../hooks/useSettings';
import type { FC } from 'react';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
  const theme = useSettings((state) => state.settings.theme);
  const direction = useSettings((state) => state.settings.direction);
  const responsiveFontSizes = useSettings((state) => state.settings.responsiveFontSizes);
  const roundedCorners = useSettings((state) => state.settings.roundedCorners);

  useEffect(() => {
    document.body.removeAttribute('class');
    document.body.classList.add('theme-' + theme);
    if (theme !== 'LIGHT') {
      document.body.classList.add('theme-DARK');
    }
  }, [theme]);

  const customTheme = useMemo(() => {
    return createCustomTheme({
      direction,
      responsiveFontSizes,
      roundedCorners,
      theme,
    });
  }, [direction, responsiveFontSizes, roundedCorners, theme]);

  return <MuiThemeProvider theme={customTheme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
